import { render, staticRenderFns } from "./FolderSelectComponent.vue?vue&type=template&id=3ffe708c&scoped=true"
import script from "./FolderSelectComponent.vue?vue&type=script&lang=js"
export * from "./FolderSelectComponent.vue?vue&type=script&lang=js"
import style0 from "./FolderSelectComponent.vue?vue&type=style&index=0&id=3ffe708c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffe708c",
  null
  
)

export default component.exports